import React from 'react';
import { Container, Typography } from '@mui/material';
import UserFilterTable from '../Components/UserFilterTable';

const UserFilterPage = () => {

  return (
    <Container>
      <Typography variant="h4"  gutterBottom>
        Список фильтров
      </Typography>
      <UserFilterTable />
    </Container>
  );
}

export default UserFilterPage;
